import React from 'react';
import './Sidebar.css';

interface MenuItem {
  label: string;
  icon: string;
  path: string;
  active?: boolean;
}

interface SidebarProps {
  menuItems: MenuItem[];
  username: string;
  onNavigate: (path: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ menuItems, username, onNavigate }) => {
  const handleLogout = () => {
    onNavigate('/logout');
  };

  const handleChangePassword = () => {
    onNavigate('/change-password');
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-text">CRYSTALCODE</span>
        </div>
      </div>

      <div className="menu-section">
        <div className="menu-title">
          <span>Menu</span>
          <span className="collapse-icon">⇄</span>
        </div>

        <nav className="nav-menu">
          {menuItems.map((item) => (
            <div
              key={item.path}
              className={`nav-item ${item.active ? 'active' : ''}`}
              onClick={() => onNavigate(item.path)}
            >
              <span className={`nav-icon ${item.icon}`}></span>
              <span className="nav-label">{item.label}</span>
            </div>
          ))}
        </nav>
      </div>

      <div className="user-section">
        <div className="user-info">
          <span className="user-icon"></span>
          <span className="username">@{username}</span>
        </div>
        
        <div className="user-actions">
          <div className="action-item" onClick={handleChangePassword}>
            <span className="action-icon password"></span>
            <span>Change Password</span>
          </div>
          <div className="action-item logout" onClick={handleLogout}>
            <span className="action-icon logout"></span>
            <span>Logout</span>
          </div>
        </div>
      </div>

      <div className="sidebar-footer">
        <div className="footer-logo">
          <span className="footer-logo-text">2THOUSAND</span>
        </div>
        <div className="copyright">
          <p>Copyright ©2025 2Thoudsand JSC. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
